import { PerspectiveGroupingRule } from './types';

export const addNewGroupingRule = (
  previousGroupingRules: PerspectiveGroupingRule[],
  newGroupingRule: PerspectiveGroupingRule,
  shouldPrepend: boolean
) => {
  return shouldPrepend
    ? [newGroupingRule, ...previousGroupingRules]
    : [...previousGroupingRules, newGroupingRule];
};

export const updateGroupingRules = (
  previousGroupingRules: PerspectiveGroupingRule[],
  updatedGroupingRuleId: string,
  updatedGroupingRulePayload: Partial<PerspectiveGroupingRule>
): PerspectiveGroupingRule[] => {
  const updatedGroupingRuleIndex = previousGroupingRules.findIndex(
    groupingRule => groupingRule.id === updatedGroupingRuleId
  );
  const previousValues = previousGroupingRules[updatedGroupingRuleIndex];

  return Object.assign([], previousGroupingRules, {
    [updatedGroupingRuleIndex]: {
      ...previousValues,
      ...updatedGroupingRulePayload,
    },
  });
};

export const deleteGroupingRule = (
  previousGroupingRules: PerspectiveGroupingRule[],
  deletedGroupingRuleId: string
) =>
  previousGroupingRules.filter(
    groupingRule => groupingRule.id !== deletedGroupingRuleId
  );
